function Unauthorized() {
  return <div>You do not have permission to view this page.</div>;
}

export default Unauthorized;
